import {
  HEALTH_CATEGORIES,
  TYPE_CATEGORIES,
  STYLE_CATEGORIES,
} from "~/lib/constants";

/**
 * 카테고리를 효능 > 종류 > 스타일 순으로 정렬하는 함수
 */
export function sortCategoriesByPriority(categories: string[]): string[] {
  const healthCategories = categories.filter((cat) =>
    HEALTH_CATEGORIES.includes(cat as any)
  );
  const typeCategories = categories.filter((cat) =>
    TYPE_CATEGORIES.includes(cat as any)
  );
  const styleCategories = categories.filter((cat) =>
    STYLE_CATEGORIES.includes(cat as any)
  );
  const otherCategories = categories.filter(
    (cat) =>
      !HEALTH_CATEGORIES.includes(cat as any) &&
      !TYPE_CATEGORIES.includes(cat as any) &&
      !STYLE_CATEGORIES.includes(cat as any)
  );

  return [
    ...healthCategories,
    ...typeCategories,
    ...styleCategories,
    ...otherCategories,
  ];
}

/**
 * 카테고리 타입에 따른 배지 색상을 반환하는 함수
 */
export function getCategoryBadgeColor(category: string): string {
  if (HEALTH_CATEGORIES.includes(category as any)) {
    // 효능 카테고리 - 주황색 (건강 관련)
    return "bg-orange-100 text-orange-800 dark:bg-orange-900 dark:text-orange-300";
  } else if (TYPE_CATEGORIES.includes(category as any)) {
    // 종류 카테고리 - 파란색 (요리 타입)
    return "bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-300";
  } else if (STYLE_CATEGORIES.includes(category as any)) {
    // 스타일 카테고리 - 보라색 (국가/스타일)
    return "bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-300";
  } else {
    // 기타 카테고리 - 회색
    return "bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300";
  }
}

/**
 * 난이도에 따른 배지 색상을 반환하는 함수
 */
export function getDifficultyBadgeColor(
  difficulty: "easy" | "medium" | "hard"
): string {
  const difficultyColors = {
    easy: "bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300",
    medium:
      "bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-300",
    hard: "bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-300",
  };

  return difficultyColors[difficulty];
}

/**
 * 난이도 한글 텍스트를 반환하는 함수
 */
export function getDifficultyText(
  difficulty: "easy" | "medium" | "hard"
): string {
  const difficultyTexts = {
    easy: "쉬움",
    medium: "보통",
    hard: "어려움",
  };

  return difficultyTexts[difficulty];
}
/**
 * RecipeCard용: 각 카테고리 타입별로 대표 하나씩만 선택하는 함수
 * 효능 > 종류 > 스타일 순으로 우선순위를 두고, 각 타입에서 첫 번째 항목만 선택
 */
export function getRepresentativeCategoriesForCard(
  categories: string[]
): string[] {
  const healthCategories = categories.filter((cat) =>
    HEALTH_CATEGORIES.includes(cat as any)
  );
  const typeCategories = categories.filter((cat) =>
    TYPE_CATEGORIES.includes(cat as any)
  );
  const styleCategories = categories.filter((cat) =>
    STYLE_CATEGORIES.includes(cat as any)
  );
  const otherCategories = categories.filter(
    (cat) =>
      !HEALTH_CATEGORIES.includes(cat as any) &&
      !TYPE_CATEGORIES.includes(cat as any) &&
      !STYLE_CATEGORIES.includes(cat as any)
  );

  const representatives: string[] = [];

  // 각 타입별로 첫 번째 항목만 선택
  if (healthCategories.length > 0) {
    representatives.push(healthCategories[0]);
  }
  if (typeCategories.length > 0) {
    representatives.push(typeCategories[0]);
  }
  if (styleCategories.length > 0) {
    representatives.push(styleCategories[0]);
  }
  if (otherCategories.length > 0 && representatives.length < 3) {
    representatives.push(otherCategories[0]);
  }

  return representatives;
}
